import { Typography, useTheme } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";
import { PMBaseCard } from "@pimo/pimo-components";

export interface CriticalFindingCardProps {
  title: string;
  headline: string;
  finding: string;
  rationale: string;
  remediation: string;
}

export const CriticalFindingCard: PimoReactComponent<
  CriticalFindingCardProps
> = ({ title, headline, finding, rationale, remediation }) => {
  const theme = useTheme();

  return (
    <PMBaseCard
      title={title}
      fixedWidth="100%"
      fixedHeight="auto"
      overflow="auto"
      contentPadding={3}
      showInfoIcon={false}
      showMenuIcon={false}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        {headline}
      </Typography>

      <Typography
        variant="overline"
        sx={{ fontWeight: 600, color: theme.palette.primary.main }}
      >
        Finding
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 400, mb: 1 }}>
        {finding}
      </Typography>

      <Typography
        variant="overline"
        sx={{ fontWeight: 600, color: theme.palette.primary.main }}
      >
        Rationale
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 400, mb: 1 }}>
        {rationale}
      </Typography>

      <Typography
        variant="overline"
        sx={{ fontWeight: 600, color: theme.palette.primary.main }}
      >
        Remediation
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 400 }}>
        {remediation}
      </Typography>
    </PMBaseCard>
  );
};

export default CriticalFindingCard;
